<template>
  <action-person-template :action="action" column="person" grid="person" title="Joueur"/>
</template>

<script>
import ActionPersonTemplate from './ActionPersonTemplate'

export default {
  name: 'SportFootballMatchActionPlayer',
  props: {
    action: Object
  },
  components: { ActionPersonTemplate }
}
</script>
